<div class="form-panel__body" [formGroup]="form">

  <!-- ── Your search ───────────────────────────────────────────────── -->
  <div class="query-section" [class.query-section--collapsed]="!sectionOpen.question">
    <div class="query-section__header" (click)="toggleSection('question')">
      <div class="query-section__header-main">
        <app-section-icon class="query-section__icon" name="search"></app-section-icon>
        <div class="query-section__header-text">
          <span class="query-section__title">Your search</span>
          <span class="query-section__desc">What you're finding similar content to</span>
        </div>
      </div>
      <span class="query-section__toggle">
        <svg class="query-section__chevron" width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <div class="query-section__body" [style.display]="sectionOpen.question ? 'flex' : 'none'">


      <div class="form-field">
        <label class="form-field__label">Query<span class="form-field__required">*</span></label>
        <app-search-bar formControlName="query" [placeholder]="QUERY_PLACEHOLDER" />
        <div class="question-row">
          <!-- Shared by the dropdown below and, on phones, the help sheet. -->
          <ng-template #helpRows>
            <div class="operators-help__row">
              <span class="operators-help__badge operators-help__badge--and">AND</span>
              <div class="operators-help__text">
                <p>Both terms must appear.</p>
                <code>Airbus AND Boeing</code>
              </div>
            </div>
            <div class="operators-help__row">
              <span class="operators-help__badge operators-help__badge--or">OR</span>
              <div class="operators-help__text">
                <p>Either term may appear.</p>
                <code>Airbus OR Boeing</code>
              </div>
            </div>
            <div class="operators-help__row">
              <span class="operators-help__badge operators-help__badge--not">NOT</span>
              <div class="operators-help__text">
                <p>Excludes a term used as <code>AND NOT</code> or <code>OR NOT</code>.</p>
                <code>Airbus AND NOT Boeing</code>
              </div>
            </div>
            <div class="operators-help__row">
              <span class="operators-help__badge operators-help__badge--syntax">" "</span>
              <div class="operators-help__text">
                <p>Matches an exact phrase.</p>
                <code>"supply chain delays"</code>
              </div>
            </div>
            <div class="operators-help__row">
              <span class="operators-help__badge operators-help__badge--syntax">( )</span>
              <div class="operators-help__text">
                <p>Groups terms to control order.</p>
                <code>(Airbus OR Boeing) AND delays</code>
              </div>
            </div>
            <p class="operators-help__note">A query can't start or end on an operator, and two operators can't sit next to each other except <code>AND NOT</code> / <code>OR NOT</code>.</p>
          </ng-template>
          <div class="dropdown" (appClickOutside)="closeOperatorsHelp()">
            <button type="button" class="link" style="font-size:12px;line-height:16px;background:none;border:none;padding:0;font-family:inherit;text-align:left;" (click)="toggleOperatorsHelp($event)">Discover Boolean operators</button>
            @if (operatorsHelpOpen) {
              <div class="operators-help dropdown__menu dropdown__menu--left">
                <p class="operators-help__title">Boolean search operators</p>
                <ng-container [ngTemplateOutlet]="helpRows" />
              </div>
            }
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- ── Request configuration ────────────────────────────────────────── -->
  <div class="query-section" [class.query-section--collapsed]="!sectionOpen.request">
    <div class="query-section__header" (click)="toggleSection('request')">
      <div class="query-section__header-main">
        <app-section-icon class="query-section__icon" name="request"></app-section-icon>
        <div class="query-section__header-text">
          <span class="query-section__title">Request configuration</span>
          <span class="query-section__desc">What gets searched content filters, countries, dates</span>
        </div>
      </div>
      <span class="query-section__toggle">
        <svg class="query-section__chevron" width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <div class="query-section__body" [style.display]="sectionOpen.request ? 'flex' : 'none'">

      <div class="form-field">
        <label class="form-field__label">Geolocated countries</label>
        <div class="ner-input-row">
          <div class="field-input field-input--tag" style="height:auto;min-height:40px;">
            @for (chip of countriesArray.controls; track $index; let i = $index) {
              <span class="chip">{{ chip.value }}&nbsp;<span class="chip__remove" (click)="removeCountryChip(i)">×</span></span>
            }
            <input type="text" class="filter-chip-input__field" placeholder="Add countries…"
                   style="border:none;background:transparent;height:auto;border-radius:0;padding:0;font-size:12px;"
                   (keydown)="onCountriesKey($event)">
          </div>
          <div class="ner-op" [class.ner-op--open]="countriesOpen" (appClickOutside)="closeCountries()">
            <button type="button" class="ner-op__trigger" (click)="toggleCountriesOp($event)">
              <span class="ner-op__label">{{ form.value.countriesOp }}</span>
              <svg class="ner-op__trigger__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 7L8 10L11 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </button>
            <div class="ner-op__dropdown" (click)="$event.stopPropagation()">
              <button type="button" class="ner-op__option" [class.ner-op__option--active]="form.value.countriesOp === 'OR'" (click)="selectCountriesOp('OR', $event)">OR</button>
              <button type="button" class="ner-op__option" [class.ner-op__option--active]="form.value.countriesOp === 'AND'" (click)="selectCountriesOp('AND', $event)">AND</button>
            </div>
          </div>
        </div>
      </div>

      <div class="form-field">
        <label class="form-field__label">Geolocated areas</label>
        <div class="field-input field-input--tag">
          @for (chip of geoAreasArray.controls; track $index; let i = $index) {
            <span class="chip">{{ chip.value }}&nbsp;<span class="chip__remove" (click)="removeGeoChip(i)">×</span></span>
          }
          <input type="text" class="filter-chip-input__field" placeholder="+ add area ID…" (keydown)="onGeoKey($event)">
        </div>
        <button type="button" class="map-btn">
          <svg class="map-btn__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 1.32L1.33 3.36A1 1 0 0 0 .75 4.27v9.12a1 1 0 0 0 1.38.93L6 12.32l4 2 4.67-2.05A1 1 0 0 0 15.25 11.3V2.18a1 1 0 0 0-1.38-.93L10 3.32l-4-2zm3 2.86v8.64l-2-1V3.18l2 1z" fill="currentColor"/></svg>
          Open map to draw areas
        </button>
      </div>

      @if (isCikisiUser) {
      <div class="cikisi-block">
        <div class="form-section__toggle-row">
          <label class="cikisi__toggle">
            <input type="checkbox" class="cikisi__input" formControlName="cikisiOnly">
            <span class="toggle__track"><span class="toggle__thumb"></span></span>
          </label>
          <div class="form-section__toggle-info">
            <span class="form-sublabel">Search only Cikisi content</span>
            <div class="form-section__status">
              <span class="status-dot status-dot--green"></span>
              <span class="form-hint">Connected</span>
              <span class="form-hint">sk-cikisi-••••••••••••••••••4f2a</span>
            </div>
          </div>
        </div>
        <div class="filter-rows">
          <p class="filter-rows__label">Filter cikisi content by</p>

          <!-- Its own on/off row, a sibling of Knowledge Topics below
               rather than folded into it (see toggleKnowledgeBase()) no
               body of its own since there's nothing to pick, just whether
               the whole knowledge base is in scope. -->
          <div class="filter-row" [class.filter-row--on]="form.value.knowledgeBase">
            <div class="filter-row__header" (click)="toggleKnowledgeBase()">
              <span class="filter-row__check" [class.filter-row__check--on]="form.value.knowledgeBase"></span>
              <span class="filter-row__label">Knowledge Base</span>
            </div>
          </div>

          @for (rowCtrl of filterRowsArray.controls; track rowCtrl; let i = $index) {
            <div
              class="filter-row"
              [class.filter-row--on]="rowCtrl.value.expanded"
              [class.filter-row--disabled]="FILTER_ROW_META[i].id === 'si-kt' && form.value.knowledgeBase"
            >
              <div class="filter-row__header" (click)="onFilterRowHeaderClick(FILTER_ROW_META[i], rowCtrl)">
                <span class="filter-row__check" [class.filter-row__check--on]="rowCtrl.value.expanded"></span>
                <span class="filter-row__label">{{ FILTER_ROW_META[i].label }}</span>
                <span class="filter-row__count" [class.filter-row__count--inactive]="!rowCtrl.value.expanded">{{ rowChipCount(rowCtrl) > 0 ? rowChipCount(rowCtrl) + ' selected' + (!rowCtrl.value.expanded ? ' (not applied)' : '') : '' }}</span>
                <svg class="filter-row__chevron" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 3.5 10.5 8 6 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
              @if (FILTER_ROW_META[i].kind === 'flat') {
                <div class="filter-row__body" [style.display]="rowCtrl.value.expanded ? 'block' : 'none'">
                  <mila-multi-select
                    [formControl]="rowSelectControlOf(rowCtrl)"
                    [fetchPage]="flatFetchers[FILTER_ROW_META[i].id]"
                    [placeholder]="FILTER_ROW_META[i].placeholder"
                  ></mila-multi-select>
                </div>
              }
            </div>
          }
        </div>
      </div>
      }

      <div class="form-field form-field--narrow">
        <label class="form-sublabel">Indexed between</label>
        <div class="form-field__date-row">
          <div class="date-picker-wrap" (appClickOutside)="closeCal(calFrom)">
            <div class="field-input field-input--date" (click)="toggleCal(calFrom, $event, 'Published from')">
              <svg class="field-input__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12C12.5523 2 13 2.44772 13 3V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H5V1.5ZM4 5V13H12V5H4Z" fill="currentColor"/></svg>
              <span class="form-hint">{{ formatDate(calFrom) || 'From' }}</span>
              @if (calFrom.selected) {
                <button type="button" class="field-input__clear" aria-label="Clear date" (click)="clearDate(calFrom, $event)">
                  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                </button>
              }
            </div>
            @if (calFrom.open) {
              <div class="cal-dropdown" (click)="$event.stopPropagation()">
                <div class="cal-header">
                  <button class="cal-nav" (click)="prevMonth(calFrom, $event)">&#8249;</button>
                  <span class="cal-month">{{ MONTH_NAMES[calFrom.month] }} {{ calFrom.year }}</span>
                  <button class="cal-nav" (click)="nextMonth(calFrom, $event)">&#8250;</button>
                </div>
                <div class="cal-grid">
                  @for (d of DAY_NAMES; track d) {
                    <div class="cal-dow">{{ d }}</div>
                  }
                  @for (day of calDays(calFrom); track $index) {
                    <div class="cal-day"
                         [class.cal-day--selected]="isSelected(calFrom, day)"
                         [class.cal-day--today]="isToday(calFrom, day)"
                         [class.cal-day--empty]="!day"
                         (click)="selectDay(calFrom, day, $event)">{{ day || '' }}</div>
                  }
                </div>
              </div>
            }
          </div>
          <div class="date-picker-wrap" (appClickOutside)="closeCal(calTo)">
            <div class="field-input field-input--date" (click)="toggleCal(calTo, $event, 'Published to')">
              <svg class="field-input__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12C12.5523 2 13 2.44772 13 3V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H5V1.5ZM4 5V13H12V5H4Z" fill="currentColor"/></svg>
              <span class="form-hint">{{ formatDate(calTo) || 'To' }}</span>
              @if (calTo.selected) {
                <button type="button" class="field-input__clear" aria-label="Clear date" (click)="clearDate(calTo, $event)">
                  <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                </button>
              }
            </div>
            @if (calTo.open) {
              <div class="cal-dropdown" (click)="$event.stopPropagation()">
                <div class="cal-header">
                  <button class="cal-nav" (click)="prevMonth(calTo, $event)">&#8249;</button>
                  <span class="cal-month">{{ MONTH_NAMES[calTo.month] }} {{ calTo.year }}</span>
                  <button class="cal-nav" (click)="nextMonth(calTo, $event)">&#8250;</button>
                </div>
                <div class="cal-grid">
                  @for (d of DAY_NAMES; track d) {
                    <div class="cal-dow">{{ d }}</div>
                  }
                  @for (day of calDays(calTo); track $index) {
                    <div class="cal-day"
                         [class.cal-day--selected]="isSelected(calTo, day)"
                         [class.cal-day--today]="isToday(calTo, day)"
                         [class.cal-day--empty]="!day"
                         (click)="selectDay(calTo, day, $event)">{{ day || '' }}</div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Moved here from Response configuration: these choose what comes
           back (same category as query/the date-range fields above), not
           how a result is shaped the way "Data fields per result" below
           (still in Response configuration) is matches the request/
           response split buildPayload() now sends on the wire, and
           /search's own layout (see similar.ts/search.ts). -->
      <div class="form-field__date-2col">
        <div class="form-field">
          <label class="form-sublabel" style="color:var(--color-text-secondary);">Sort by</label>
          <select class="field-select" formControlName="sortBy">
            @for (opt of SORT_OPTIONS; track opt.value) {
              <option [value]="opt.value">{{ opt.label }}</option>
            }
          </select>
        </div>
        <div class="form-field">
          <div style="display:flex;flex-direction:column;gap:4px;">
            <label class="form-sublabel" style="color:var(--color-text-secondary);">Max results</label>
            <span class="form-hint">Range: {{ MIN_RESULTS }}–{{ MAX_RESULTS }}. Varies based on selected data fields.</span>
          </div>
          <div class="num-stepper">
            <button type="button" class="num-stepper__btn" aria-label="Decrease" [disabled]="form.value.maxResults <= MIN_RESULTS" (click)="decrementResults()">−</button>
            <div class="num-stepper__value">{{ form.value.maxResults }}</div>
            <button type="button" class="num-stepper__btn" aria-label="Increase" [disabled]="form.value.maxResults >= MAX_RESULTS" (click)="incrementResults()">+</button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- ── Response configuration collapsed by default: set once, rarely revisited ── -->
  <div class="query-section" [class.query-section--collapsed]="!sectionOpen.response">
    <div class="query-section__header" (click)="toggleSection('response')">
      <div class="query-section__header-main">
        <app-section-icon class="query-section__icon" name="response"></app-section-icon>
        <div class="query-section__header-text">
          <span class="query-section__title">Response configuration</span>
          <span class="query-section__desc">How each result is shaped</span>
        </div>
      </div>
      <span class="query-section__toggle">
        <svg class="query-section__chevron" width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <div class="query-section__body" [style.display]="sectionOpen.response ? 'flex' : 'none'">

      <div class="form-field" formGroupName="fields">
        <label class="form-sublabel">Data fields per result</label>
        <div class="cb-grid">
          <div class="cb-grid__col">
            @for (f of FIELD_META.slice(0, 7); track f.key) {
              <label class="cb-pill"><input type="checkbox" class="cb-pill__input" [formControlName]="f.key">{{ f.label }}{{ f.required ? ' *' : '' }}</label>
            }
          </div>
          <div class="cb-grid__col">
            @for (f of FIELD_META.slice(7); track f.key) {
              <label class="cb-pill"><input type="checkbox" class="cb-pill__input" [formControlName]="f.key">{{ f.label }}</label>
            }
          </div>
        </div>
      </div>

    </div>
  </div>

</div>
